'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var constants$1 = require('./constants-1c2e2b2b.js');

var ButtonBlock = function (_a) {
    var text = _a.text, buttonLabel = _a.buttonLabel, onClick = _a.onClick, _b = _a.ButtonWrapper, ButtonWrapper = _b === void 0 ? React.Fragment : _b;
    return (React__default.createElement(constants$1.Block, null,
        React__default.createElement(constants$1.Title, null, text),
        React__default.createElement(ButtonWrapper, null,
            React__default.createElement(constants$1.StyledButton, { text: buttonLabel, onClick: onClick, variant: "secondary" }))));
};

exports.ButtonBlock = ButtonBlock;
